exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  width: 100%; }\n\n.map {\n  margin: 20px 0 30px;\n  height: 700px;\n  border-radius: 2px; }\n  .map map {\n    width: 1024px; }\n    .map map.block {\n      padding: 0; }\n\n@media (min-width: 320px) and (max-width: 480px) {\n  .map {\n    height: 500px !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/interactive-map.component.scss
// module id = ../../../../../src/app/pages/interactive-map.component.scss
// module chunks = main